
import React, { useState, useEffect } from 'react';
import { Cookie, ShieldCheck, X } from 'lucide-react';
import { Link } from 'react-router-dom';

export const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check local storage for consent
    const consent = localStorage.getItem('lumina_cookie_consent');
    if (!consent) {
      // Small delay for animation effect
      const timer = setTimeout(() => setIsVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('lumina_cookie_consent', 'accepted');
    setIsVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem('lumina_cookie_consent', 'declined');
    setIsVisible(false);
  };

  return (
    <>
      {/* COOKIE BANNER */}
      {isVisible && (
        <div className="fixed bottom-6 left-6 right-6 md:left-auto md:right-6 md:max-w-md z-[100] animate-fade-in-up">
          <div className="bg-white/90 backdrop-blur-xl border border-white/50 shadow-2xl rounded-2xl p-6 relative overflow-hidden">
            {/* Decorative background element */}
            <div className="absolute top-0 right-0 w-32 h-32 bg-brand-lime/10 rounded-full blur-2xl -translate-y-1/2 translate-x-1/2 pointer-events-none" />

            <div className="relative z-10">
              <div className="flex items-start gap-4 mb-4">
                <div className="p-3 bg-brand-lime/20 rounded-xl text-brand-dark shrink-0">
                  <Cookie size={24} />
                </div>
                <div>
                  <h3 className="font-bold text-gray-900 text-lg">Privacy & Cookies</h3>
                  <p className="text-sm text-gray-600 mt-1 leading-relaxed">
                    We use cookies and AI tracking to optimize your experience and analyze traffic.
                    See our <Link to="/legal/cookie-policy" className="text-brand-lime hover:underline font-bold" onClick={() => setIsVisible(false)}>Cookie Policy</Link>.
                  </p>
                </div>
              </div>

              <div className="flex gap-3">
                <button
                  onClick={handleDecline}
                  className="flex-1 py-2.5 rounded-lg border border-gray-200 text-gray-600 text-sm font-bold hover:bg-gray-50 transition-colors"
                >
                  Opt-out
                </button>
                <button
                  onClick={handleAccept}
                  className="flex-1 py-2.5 rounded-lg bg-brand-dark text-white text-sm font-bold hover:bg-black transition-colors shadow-lg flex items-center justify-center gap-2"
                >
                  <ShieldCheck size={16} /> Accept All
                </button>
              </div>
            </div>

            <button
              onClick={() => setIsVisible(false)}
              className="absolute top-2 right-2 p-2 text-gray-400 hover:text-gray-600 transition-colors"
            >
              <X size={16} />
            </button>
          </div>
        </div>
      )}
    </>
  );
};
